import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { bool, func, shape } from "prop-types";
import * as i18n from "util/i18n";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import { useLocation, useParams } from "react-router-dom";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import Button from "pages/_components/Button";
import { TransactionCard, TransactionHeader, TransactionSign } from "pages/_components/TransactionCard";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import gaEventTracker, { events } from "util/gaEventTracker";
import { isEmpty } from "lodash";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { push } from "connected-react-router";
import { ResponsiveHeader } from "pages/_components/header";

const CustomLoanTransactionPage = ({ dispatch, fetching, transaction, isDesktop }) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const isLoading = fetching || !transaction?.data;
    const isBackoffice = pathname.includes("backoffice");
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "accounts.create.transactionRequest.secondTitle",
        id,
        "accounts",
    );

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id, dispatch]);


    const [showMoreData, setShowMoreData] = useState(!isDesktop);

    const handleDownload = async () => {
        gaEventTracker.triggerEvent(events.cuentas_solicitud_descargar());
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <Fragment>
            <Notification scopeToShow="accounts" />{" "}
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle="Solicitud de prestamo a medida" />
            )}
{            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                            //subTitle={`forms.transaction.ticket.status.${transaction.idTransactionStatus}`}
                        />
                            <div className="ticket" style={{ backgroundColor: "unset" }}>
                                <div className="ticket__wrapper" style={{ backgroundColor: "#fff" }}>
                                    <div className="ticket__header" />
                                    <div className="ticket__body echeq-massive-emit">
                                        <div
                                            className="grid-table-data flex"
                                            style={{
                                                gridArea: "1 / 1 / span 1 / span 8",
                                                justifyContent: "center",
                                                flexDirection: "row",
                                                textAlign: "center",
                                            }}>
                                            <div
                                                className={`ticket-section ${isDesktop && " flex"}`}
                                                style={{ alignItems: "center" }}>
                                                <CustomData
                                                    keepSpaceIfNotitle
                                                    titleTextType="I18N"
                                                    titleText="loans.customLoan.form.amount"
                                                    valueText={transaction?.data?.amount || '""'}
                                                    valueTextType="MONEY"
                                                />
                                                <CustomData
                                                    keepSpaceIfNotitle
                                                    titleTextType="I18N"
                                                    titleText="loans.customLoan.form.destinyFunds"
                                                    valueText={transaction?.data?.destinyFunds || '""'}
                                                    valueTextType="TEXT"
                                                />
                                                {isBackoffice && (
                                                    <>
                                                        <CustomData
                                                            keepSpaceIfNotitle
                                                            titleTextType="I18N"
                                                            titleText="loans.customLoan.form.documentation.file.lastBalance"
                                                            valueText={transaction?.data?.documentLastBalance || '""'}
                                                            valueTextType="TEXT"
                                                        />
                                                        <CustomData
                                                            keepSpaceIfNotitle
                                                            titleTextType="I18N"
                                                            titleText="loans.customLoan.form.documentation.file.salesAfterBalance"
                                                            valueText={transaction?.data?.documentSalesAfterBalance || '""'}
                                                            valueTextType="TEXT"
                                                        />
                                                        <CustomData
                                                            keepSpaceIfNotitle
                                                            titleTextType="I18N"
                                                            titleText="loans.customLoan.form.documentation.file.cashflow"
                                                            valueText={transaction?.data?.documentCashflow || '""'}
                                                            valueTextType="TEXT"
                                                        />
                                                </>)}
                                            </div>
                                        </div>

                                    </div>
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                                {!isBackoffice && (
                                    <Row className="form-actions element-to-ignore no-print">
                                        {isDesktop && (
                                            <Col md={6} xs={12}>
                                                <Button
                                                    className="btn btn-outline"
                                                    label="forms.transaction.ticket.actions.backToHome"
                                                    onClick={() => dispatch(push("/desktop"))}
                                                />
                                            </Col>
                                        )}
                                        <Col xs={12} md={6}>
                                            <Button
                                                style={!isDesktop ? { marginTop: "15px" } : {}}
                                                onClick={handleDownload}
                                                label="global.download"
                                                className="btn btn-primary element-to-ignore"
                                                image="images/download.svg"
                                            />
                                        </Col>
                                        {!isDesktop && (
                                            <Col xs={12} md={6}>
                                                <Button
                                                    className="btn btn-outline element-to-ignore"
                                                    image="images/figma/icon/share.svg"
                                                    label="global.share"
                                                    onClick={() => {
                                                        handleShareMobile();
                                                    }}
                                                />
                                            </Col>
                                        )}
                                    </Row>
                                )}
                            </div>
                        </TransactionCard>
                    </div>
                </div>
            </MainContainer>}
        </Fragment>
    );
};

CustomLoanTransactionPage.propTypes = {
    transaction: shape({}).isRequired,
    dispatch: func.isRequired,
    fetching: bool,
    isDesktop: bool.isRequired,
};

CustomLoanTransactionPage.defaultProps = {
    fetching: false,
};

const mapStateToProps = (state) => ({
    transaction: formSelectors.getTransaction(state),
});

export default connect(mapStateToProps)(CustomLoanTransactionPage);
